import StaticPageForm from './static-page-form';

export default StaticPageForm;
